export const getProgressText = (p) => {
  let text = '<未开始>'
  if (p.type?.progressType === 0) {
    if (p.extraData.totalProgress) {
      text = `${p.progresses[p.progresses.length - 1]?.currentProgress ?? '0'} / ${p.extraData.totalProgress}` + (p.extraData.progressUnit ? ` ${p.extraData.progressUnit}` : '')
    }
    else
      text = p.progresses[p.progresses.length - 1]?.currentProgress ?? text
  }
  else if (p.type?.progressType === 1) {
    text = p.progresses[p.progresses.length - 1]?.currentProgress ?? text
  }
  return text
}

export const calculateProgress = (p) => {
  let progress = '0'
  if (p.type?.progressType === 0) {
    if (p.extraData.totalProgress) {
      const last = p.progresses[p.progresses.length - 1]?.currentProgress ?? '0'
      progress = (divide(last, p.extraData.totalProgress) * 100).toFixed(2) + '%'
    }
    else
      progress = '0%'
  }
  else if (p.type?.progressType === 1) {
    if (p.extraData.steps?.length > 0) {
      const last = p.progresses[p.progresses.length - 1]?.currentProgress
      if (last) {
        progress = ((p.extraData.steps.indexOf(last) + 1) / p.extraData.steps.length * 100).toFixed(2) + '%'
      }
      else
        progress = '0%'
    }
    else
      progress = '0%'
  }
  return progress

  function divide(a, b) {
    try {
      const isTime = b.includes(':')

      if (isTime) {
        const toSeconds = s => {
          const parts = s.split(':').map(Number)
          if (parts.some(isNaN)) throw new Error()
          if (parts.length === 2) {
            const [m, s] = parts
            return m * 60 + s
          } else if (parts.length === 3) {
            const [h, m, s] = parts
            return h * 3600 + m * 60 + s
          } else throw new Error()
        }
        const secA = toSeconds(a)
        const secB = toSeconds(b)
        return secB === 0 ? 0 : secA / secB
      } else {
        const numA = parseFloat(a)
        const numB = parseFloat(b)
        if (isNaN(numA) || isNaN(numB) || numB === 0) return 0
        return numA / numB
      }
    } catch {
      return 0
    }
  }
}